/* ============================================================
   GOD SELECTION XXX — Custom JS
   ============================================================ */

// ─── Drawer stacking: last-opened drawer appears on top ───────
// Cart drawer z-index: var(--xxx-z-cart-drawer, 101)
// Header (contains menu drawer) z-index: var(--xxx-z-header, 100)
// Whichever opens last gets z-index 103; the other gets 101/100.
(function drawerStacking() {
  const root = document.documentElement;

  function bringCartFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '103');
    root.style.setProperty('--xxx-z-header', '100');
  }
  function bringMenuFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '101');
    root.style.setProperty('--xxx-z-header', '103');
  }
  function resetStacking() {
    root.style.removeProperty('--xxx-z-cart-drawer');
    root.style.removeProperty('--xxx-z-header');
  }

  // Watch cart drawer active class
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) {
        bringCartFront();
      } else if (!document.querySelector('#Details-menu-drawer-container[open]')) {
        resetStacking();
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch menu drawer details[open]
  const menuDetails = document.querySelector('#Details-menu-drawer-container');
  if (menuDetails) {
    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.open) {
        bringMenuFront();
      } else if (!cartDrawer?.classList.contains('active')) {
        resetStacking();
      }
    });
  }
})();

// ─── Card: resolve the current destination URL for a card ────
// Returns the variant URL if a swatch is active, otherwise the plain product URL.
function cardDestUrl(card) {
  const variantUrl = card.dataset.xxxVariantUrl;
  if (variantUrl) return variantUrl;
  const link = card.querySelector('.card__heading a');
  return link ? link.getAttribute('href') : null;
}

// ─── Color Swatch: image swap + variant URL update ───────────
// Click on .xxx-swatch → swap the card image, update active state,
// and store the variant URL on the card for image-click navigation.
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.xxx-swatch');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  e.preventDefault();
  e.stopPropagation();

  // Update active dot
  card.querySelectorAll('.xxx-swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');

  // Swap primary image
  const imgUrl = swatch.dataset.variantImage;
  if (imgUrl) {
    const img = card.querySelector('.xxx-card-img');
    if (img) {
      // Remove srcset/sizes so subsequent src changes always take effect
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imgUrl;
    }
  }

  // Store variant URL on card so image click can navigate to correct variant
  const variantId = swatch.dataset.variantId;
  if (variantId) {
    const baseLink = card.querySelector('.card__heading a');
    const baseUrl = baseLink ? baseLink.getAttribute('href').split('?')[0] : '';
    const variantUrl = baseUrl + '?variant=' + variantId;
    card.dataset.xxxVariantUrl = variantUrl;
    // Also update heading links so keyboard / right-click open-in-tab works correctly
    card.querySelectorAll('.card__heading a').forEach(a => a.setAttribute('href', variantUrl));
  }
});

// ─── Card image click → navigate to (variant) product page ───
// The full-card ::after overlay is disabled via CSS (pointer-events:none).
// This handler restores click-to-navigate on the product image only.
document.addEventListener('click', function (e) {
  const img = e.target.closest('.xxx-card-img');
  if (!img) return;

  const card = img.closest('.card-wrapper');
  if (!card) return;

  const url = cardDestUrl(card);
  if (url) window.location.href = url;
});

// ─── Product card HOVER IMAGE ────────────────────────────────
// On hover, reveal a second image over the card:
//   1. If custom.hover_image metafield is set → show it (priority).
//   2. Otherwise → show the image AFTER the one currently displayed.
//      Follows colour-swatch selection (matches by URL path, ignoring the
//      width/version query). If the current image is the last → wrap to first.
// The overlay <img.xxx-card-hover-img> and data-* attrs are emitted by
// snippets/card-product.liquid only when a hover target exists.
(function () {
  if (window.__xxxCardHoverInit) return;
  window.__xxxCardHoverInit = true;

  // Normalise any image URL to its pathname so we can match the same image
  // regardless of origin/protocol (dev proxies CDN under localhost; prod uses
  // cdn.shopify.com) and ignore the ?v=…&width=… query entirely.
  function pathKey(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.href).pathname;
    } catch (err) {
      return url.split('?')[0];
    }
  }

  function computeHoverSrc(media, card) {
    // Priority 1: metafield hover image
    var mf = media.getAttribute('data-xxx-hover-image');
    if (mf) return mf;

    // Priority 2: next image after the one currently shown
    var list;
    try {
      list = JSON.parse(media.getAttribute('data-xxx-images') || '[]');
    } catch (err) {
      return null;
    }
    if (!list || list.length <= 1) return null;

    var primary = (card || media).querySelector('.xxx-card-img');
    var curKey = primary ? pathKey(primary.currentSrc || primary.src) : '';

    var idx = -1;
    for (var i = 0; i < list.length; i++) {
      if (pathKey(list[i]) === curKey) { idx = i; break; }
    }
    if (idx === -1) idx = 0; // current not found → treat as first

    var next = (idx + 1) % list.length;
    if (pathKey(list[next]) === curKey) return null; // would be the same image
    return list[next];
  }

  // Point the overlay at its computed hover target (next image / metafield).
  // Returns the overlay element, or null when there's nothing to show. Does
  // NOT reveal it — the caller decides when, via revealWhenLoaded().
  function primeHover(card) {
    var media = card.querySelector('[data-xxx-hover]');
    if (!media) return null;
    var overlay = media.querySelector('.xxx-card-hover-img');
    if (!overlay) return null;
    var src = computeHoverSrc(media, card);
    if (!src) return null;
    if (overlay.getAttribute('src') !== src) {
      overlay.classList.remove('is-shown'); // start hidden so it can fade in
      overlay.setAttribute('src', src);
    }
    return overlay;
  }

  // Reveal once the image has loaded — but only if `stillActive()` is still
  // true at that moment (pointer still over the card / finger still pressing).
  // Gating on load means the opacity fade always plays instead of popping in.
  function revealWhenLoaded(overlay, stillActive) {
    var go = function () { if (stillActive()) overlay.classList.add('is-shown'); };
    if (overlay.complete && overlay.naturalWidth > 0) go();
    else overlay.onload = go;
  }

  function hideHover(card) {
    var media = card.querySelector('[data-xxx-hover]');
    if (!media) return;
    var overlay = media.querySelector('.xxx-card-hover-img');
    if (overlay) overlay.classList.remove('is-shown'); // fades back out
  }

  function hoverAreaFrom(target) {
    if (!target || !target.closest) return null;
    var area = target.closest('.card__media');
    if (!area) return null;
    var card = area.closest('.card-wrapper');
    if (!card || !area.querySelector('[data-xxx-hover]')) return null;
    return { area: area, card: card };
  }

  // ── Mouse: hover-capable pointers (skip touch, which has no hover state) ──
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var hit = hoverAreaFrom(e.target);
      if (!hit) return;
      if (e.relatedTarget && hit.area.contains(e.relatedTarget)) return; // internal move
      var overlay = primeHover(hit.card);
      if (overlay) revealWhenLoaded(overlay, function () { return hit.area.matches(':hover'); });
    });
    document.addEventListener('mouseout', function (e) {
      var hit = hoverAreaFrom(e.target);
      if (!hit) return;
      if (e.relatedTarget && hit.area.contains(e.relatedTarget)) return; // still inside image area
      hideHover(hit.card);
    });
  }

  // ── Touch: reveal the card under the finger ──
  // While a finger is on the screen, the card directly beneath it shows its
  // next image — and as the page scrolls (or the finger slides), whichever
  // card passes under the finger reveals in turn. Lifting reverts. A tap still
  // navigates (the overlay is pointer-events:none).
  (function () {
    var activeCard = null;

    function cardAt(x, y) {
      var el = document.elementFromPoint(x, y);
      var hit = hoverAreaFrom(el);
      return hit ? hit.card : null;
    }

    function moveTo(card) {
      if (card === activeCard) return;
      if (activeCard) hideHover(activeCard); // revert the one we left
      activeCard = card;
      if (!card) return;
      var overlay = primeHover(card);
      if (overlay) revealWhenLoaded(overlay, function () { return activeCard === card; });
    }

    function end() {
      if (activeCard) hideHover(activeCard);
      activeCard = null;
    }

    document.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || !e.target.closest) return;
      var hit = hoverAreaFrom(e.target);
      moveTo(hit ? hit.card : null);
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      moveTo(cardAt(t.clientX, t.clientY)); // follow the finger across cards
    }, { passive: true });

    document.addEventListener('touchend', end);
    document.addEventListener('touchcancel', end);
  })();
})();

// ─── Undefined swatch detection ──────────────────────────────
// Adds .swatch--undefined to any swatch whose color variable resolves
// to an unrecognised CSS colour name. Uses a hidden test element to
// probe the browser's colour parser: valid colours produce a non-empty
// computed style; invalid ones produce an empty string.
(function markUndefinedSwatches() {
  const probe = document.createElement('div');
  probe.style.display = 'none';
  document.body.appendChild(probe);

  function isValidColor(value) {
    if (value.startsWith('url(')) return true; // image swatch (PNG from files)
    probe.style.backgroundColor = '';
    probe.style.backgroundColor = value;
    return probe.style.backgroundColor !== '';
  }

  function scan() {
    // Product detail page: Dawn .swatch with --swatch--background
    document.querySelectorAll('.swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--swatch--background').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });

    // Product cards: .xxx-swatch with --xxx-swatch-bg
    document.querySelectorAll('.xxx-swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--xxx-swatch-bg').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when new content is injected (e.g. quick-add, recommendations)
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

// ─── Cart Exclusivity Guard: LIMITED ORDER vs in-stock ────────
// 受注生産商品(タグ "LIMITED ORDER") と 通常在庫商品 を
// 同一カートに混在させない。混在しそうな add-to-cart を捕捉して
// 確認モーダルを出し、ユーザー同意で既存カートをクリア → 追加し直す。
//
// 識別方法: LIMITED ORDER 追加時に hidden line item property
//   `properties[_limited_order]=1` を付ける。`_` プレフィックスは
//   Shopify がカートUIから非表示にする慣習。
//
// 仕組み: capture-phase の submit リスナでフォームを捕捉し、
//   product-form 配下なら preventDefault → /cart.js 確認 → 判定 →
//   問題なければ form.requestSubmit() で本来のハンドラに引き渡す。
(function cartExclusivityGuard() {
  const LIMITED_TAG = 'limited order';
  const LIMITED_PROP = '_limited_order';
  const BYPASS_KEY = '__xxxGuardBypass';

  function isLimitedTags(tagsStr) {
    if (!tagsStr) return false;
    return tagsStr.split(',').some(t => t.trim().toLowerCase() === LIMITED_TAG);
  }

  function cartIsLimited(cart) {
    return (cart.items || []).some(item => item.properties && item.properties[LIMITED_PROP]);
  }

  function ensureLimitedProperty(form, isLimited) {
    form.querySelectorAll('input[data-xxx-limited-marker]').forEach(el => el.remove());
    if (!isLimited) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + LIMITED_PROP + ']';
    input.value = '1';
    input.setAttribute('data-xxx-limited-marker', '');
    form.appendChild(input);
  }

  function resubmit(form) {
    form[BYPASS_KEY] = true;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      // 旧ブラウザフォールバック
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
      else form.submit();
    }
  }

  function showModal(opts) {
    const addingLimited = opts.addingLimited;
    const existing = document.getElementById('xxx-cart-guard-modal');
    if (existing) existing.remove();

    const message = addingLimited
      ? 'こちらは受注生産商品のため、通常商品と同時にご注文いただけません。<br>カート内の通常商品を削除して、この受注生産商品を追加しますか?'
      : 'カート内に受注生産商品があります。<br>受注生産商品を削除して、こちらの商品を追加しますか?';

    const modal = document.createElement('div');
    modal.id = 'xxx-cart-guard-modal';
    modal.className = 'xxx-cart-guard__overlay';
    modal.innerHTML =
      '<div class="xxx-cart-guard__panel" role="dialog" aria-modal="true" aria-labelledby="xxx-cart-guard__title">' +
        '<h2 id="xxx-cart-guard__title" class="xxx-cart-guard__title">カートを切り替えますか?</h2>' +
        '<p class="xxx-cart-guard__message">' + message + '</p>' +
        '<div class="xxx-cart-guard__actions">' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--secondary" data-action="cancel">キャンセル</button>' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--primary" data-action="confirm">カートを切り替える</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    document.body.classList.add('xxx-cart-guard-open');

    function close() {
      modal.remove();
      document.body.classList.remove('xxx-cart-guard-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) { close(); return; }
      const action = e.target.dataset && e.target.dataset.action;
      if (action === 'cancel') close();
      if (action === 'confirm') { close(); opts.onConfirm(); }
    });
    document.addEventListener('keydown', onKey);

    const focusBtn = modal.querySelector('[data-action="confirm"]');
    if (focusBtn) focusBtn.focus();
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // 自身による再送信はスルー
    if (form[BYPASS_KEY]) { delete form[BYPASS_KEY]; return; }

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const addingLimited = isLimitedTags(productForm.dataset.productTags || '');

    // 非同期判定のため一旦遮断
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const hasItems = (cart.items || []).length > 0;
        const cartLimited = cartIsLimited(cart);
        const conflict = hasItems && (cartLimited !== addingLimited);

        if (!conflict) {
          ensureLimitedProperty(form, addingLimited);
          resubmit(form);
          return;
        }

        showModal({
          addingLimited: addingLimited,
          onConfirm: function () {
            fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
              .then(() => {
                ensureLimitedProperty(form, addingLimited);
                resubmit(form);
              })
              .catch(err => {
                console.error('[XXX Cart Guard] clear failed', err);
              });
          }
        });
      })
      .catch(err => {
        console.error('[XXX Cart Guard] cart fetch failed', err);
        // フォールバック: 判定失敗時はそのまま追加
        ensureLimitedProperty(form, addingLimited);
        resubmit(form);
      });
  }, true);
})();


/* ============================================================
   KEY VISUAL SLIDER (xxx-keyvisual-slider section)
   ============================================================
   Lightweight self-contained slider. No external deps.
   - dot indicators + touch swipe
   - optional autoplay (data-autoplay), pauses on hover/touch
   - plays only the active slide's video, pauses the rest
   - Shopify theme editor aware (block select / section load)
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // `root` is a single pane ([data-xxx-kvs-pane]); each pane is an independent
  // slider so desktop and mobile can carry a different number of slides.
  function XXXKeyVisualSlider(root) {
    this.root = root;
    var section = root.closest('[data-xxx-kvs]') || root;
    this.track = root.querySelector('[data-xxx-kvs-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-xxx-kvs-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-xxx-kvs-dot]'));
    this.index = 0;
    this.count = this.slides.length;
    this.autoplay = section.hasAttribute('data-autoplay') && !prefersReduced;
    this.interval = parseInt(section.getAttribute('data-interval'), 10) || 5000;
    this.timer = null;

    if (!this.track || this.count <= 1) {
      this.playActiveVideo();
      return;
    }
    this.bind();
    this.goTo(0, true);
    this.start();
  }

  XXXKeyVisualSlider.prototype.goTo = function (i, instant) {
    this.index = (i + this.count) % this.count;
    if (instant) this.track.classList.add('is-dragging');
    this.track.style.transform = 'translate3d(' + (-this.index * 100) + '%, 0, 0)';
    if (instant) {
      // force reflow then re-enable transition
      void this.track.offsetWidth;
      this.track.classList.remove('is-dragging');
    }
    this.dots.forEach(function (dot, n) {
      var active = n === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    }, this);
    this.playActiveVideo();
  };

  XXXKeyVisualSlider.prototype.next = function () { this.goTo(this.index + 1); };
  XXXKeyVisualSlider.prototype.prev = function () { this.goTo(this.index - 1); };

  XXXKeyVisualSlider.prototype.playActiveVideo = function () {
    this.slides.forEach(function (slide, n) {
      var vids = slide.querySelectorAll('video');
      Array.prototype.forEach.call(vids, function (v) {
        if (n === this.index) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }, this);
    }, this);
  };

  XXXKeyVisualSlider.prototype.start = function () {
    if (!this.autoplay) return;
    this.stop();
    var self = this;
    this.timer = window.setInterval(function () { self.next(); }, this.interval);
  };
  XXXKeyVisualSlider.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  XXXKeyVisualSlider.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-index'), 10));
        self.start();
      });
    });

    // pause autoplay on hover (desktop)
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.start(); });

    // touch swipe
    var startX = 0, startY = 0, dx = 0, dragging = false;
    var THRESHOLD = 40;

    this.track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = true;
      self.stop();
      self.track.classList.add('is-dragging');
    }, { passive: true });

    this.track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      // ignore mostly-vertical gestures (let the page scroll)
      if (Math.abs(dy) > Math.abs(dx)) return;
      var pct = (-self.index * 100) + (dx / self.root.offsetWidth * 100);
      self.track.style.transform = 'translate3d(' + pct + '%, 0, 0)';
    }, { passive: true });

    this.track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      self.track.classList.remove('is-dragging');
      if (dx <= -THRESHOLD) self.next();
      else if (dx >= THRESHOLD) self.prev();
      else self.goTo(self.index);
      self.start();
    });
  };

  // one slider instance per pane (desktop pane + mobile pane)
  function initAll(scope) {
    var panes = (scope || document).querySelectorAll('[data-xxx-kvs-pane]');
    Array.prototype.forEach.call(panes, function (pane) {
      if (pane.__xxxKvs) return;
      pane.__xxxKvs = new XXXKeyVisualSlider(pane);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Shopify theme editor: re-init on section load, jump to selected block.
  // A block can appear in both panes; move whichever pane contains the
  // selected element to that slide.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-xxx-kvs-slide]');
    var pane = e.target.closest('[data-xxx-kvs-pane]');
    if (slide && pane && pane.__xxxKvs) {
      pane.__xxxKvs.stop();
      pane.__xxxKvs.goTo(parseInt(slide.getAttribute('data-index'), 10) || 0);
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var pane = e.target.closest('[data-xxx-kvs-pane]');
    if (pane && pane.__xxxKvs) pane.__xxxKvs.start();
  });
})();

/* ─── COMING SOON: 購入ボタンに発売日ラベルを保持 ────────────────
   Coming Soon商品は品切れ(在庫0)だが完売ではなく発売前。購入ボタンは
   発売日ラベル(例 "YYYY.MM.DD RELEASE")を表示し、常に非活性に保つ。
   Dawn の product-info.js はバリアント変更時 toggleSubmitButton() で
   ボタン文言を variantStrings.soldOut('SOLD OUT')に上書きするため、
   data-coming-soon-label を正として再適用する(コアJSは触らない方針)。 */
(function comingSoonButtonGuard() {
  function guard(btn) {
    var label = btn.getAttribute('data-coming-soon-label');
    if (!label) return;
    var span = btn.querySelector('span');
    if (!span) return;
    function enforce() {
      if (!btn.hasAttribute('disabled')) btn.setAttribute('disabled', 'disabled');
      if (span.textContent.trim() !== label) span.textContent = label;
    }
    enforce();
    new MutationObserver(enforce).observe(btn, {
      childList: true, subtree: true, characterData: true, attributes: true
    });
  }
  function init(scope) {
    (scope || document)
      .querySelectorAll('.product-form__submit[data-coming-soon-label]')
      .forEach(guard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // テーマエディタでセクション再読込された場合も再適用
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ─── 閲覧履歴 (sections/xxx-recently-viewed.liquid) ────────────────
   表示中の商品の handle を localStorage に新しい順で記録し、それ以外を
   最大 data-limit 件まで表示する。カードは各商品 URL にこのセクションを
   section_id 指定で要求し、レスポンス内 template のカードを取り出す
   (関連商品と同じ card-product・同じ設定で描画される)。
   取得できない商品 (非公開・削除) は履歴から外す。
   スクロールを待たず、ページを開いた直後に読み込む。
   localStorage が使えない環境では記録も表示もしない。 */
(function recentlyViewed() {
  var KEY = 'xxx:recently-viewed';
  var MAX_STORED = 20;

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (h, i) { return typeof h === 'string' && h && list.indexOf(h) === i; });
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {}
  }
  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  if (customElements.get('xxx-recently-viewed')) return;

  customElements.define('xxx-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      var current = this.dataset.productHandle;
      var history = read().filter(function (h) { return h !== current; });
      if (current) write([current].concat(history));

      this.limit = parseInt(this.dataset.limit, 10) || 4;
      // 非公開・削除で欠ける分を見込んで多めに取りに行き、先頭から limit 件を出す
      this.handles = history.slice(0, this.limit * 2);
      if (!this.handles.length) return;

      // スクロールを待たず、ページを開いた直後に読み込む
      this.load();
    }

    load() {
      if (this.loading) return;
      this.loading = true;
      var self = this;
      var sectionId = this.dataset.sectionId;
      var requests = this.handles.map(function (handle) {
        var url = rootUrl() + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(sectionId);
        return fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var tpl = doc.querySelector('template[data-recently-viewed-card]');
            var card = tpl && tpl.content.querySelector('.grid__item');
            return card ? { handle: handle, card: card } : { handle: handle, gone: true };
          })
          .catch(function (err) {
            // 404 = 非公開・削除。通信エラー等は履歴に残す
            return { handle: handle, gone: String(err.message) === '404' };
          });
      });

      Promise.all(requests).then(function (results) {
        var gone = results.filter(function (r) { return r.gone; }).map(function (r) { return r.handle; });
        if (gone.length) {
          write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
        }
        var list = self.querySelector('[data-recently-viewed-list]');
        var cards = results.filter(function (r) { return r.card; }).slice(0, self.limit);
        if (!list || !cards.length) return;
        list.replaceChildren();
        cards.forEach(function (r) { list.appendChild(document.importNode(r.card, true)); });
        self.hidden = false;
      });
    }
  });
})();

/* ─── 関連商品: ページを開いた直後に読み込む ────────────────────────
   Dawn の product-recommendations (assets/global.js) は画面の 400px 手前まで
   スクロールしてから取りに行くため、一瞬遅れて表示される。
   コアJSは触らず、Dawn の監視を止めて読み込みだけ先に呼ぶ。
   global.js は custom.js より先に defer で読まれるので、この時点で要素は定義済み。 */
(function loadRelatedProductsEarly() {
  function run(scope) {
    (scope || document).querySelectorAll('product-recommendations.related-products').forEach(function (el) {
      if (el.dataset.xxxEarlyLoaded || typeof el.loadRecommendations !== 'function') return;
      el.dataset.xxxEarlyLoaded = 'true';
      if (el.observer) el.observer.disconnect();
      el.loadRecommendations(el.dataset.productId);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }
})();

/* ─── メニュードロワー: 開いたあと項目を上から順に表示する ─────────────
   ドロワーが開き終わってから (0.3s)、項目を 0.1s ずつずらして
   下から 8px 浮かせつつフェードイン (各 0.15s)。最後にフッターを 0.3s で表示。
   ずらす単位は「見出し / 1 つのリンク / 親リンク + その下の子リンク」。
   ここでは順番 (--xxx-reveal-i) を振るだけで、動きは custom.css で付ける。
   JS が動かない環境では何も隠さない。 */
(function drawerStaggerReveal() {
  function index(root) {
    var nav = (root || document).querySelector('#menu-drawer .xxx-drawer-nav');
    if (!nav || nav.dataset.xxxRevealIndexed) return;
    nav.dataset.xxxRevealIndexed = 'true';
    var i = -1;
    var pendingDividers = [];
    function mark(el, n) {
      el.classList.add('xxx-reveal-item');
      el.style.setProperty('--xxx-reveal-i', n);
    }
    Array.prototype.forEach.call(nav.children, function (block) {
      if (block.classList.contains('xxx-drawer-divider')) {
        pendingDividers.push(block);
        return;
      }
      Array.prototype.forEach.call(block.children, function (el) {
        if (!el.classList.contains('xxx-drawer-link--sub')) i += 1;
        mark(el, Math.max(i, 0));
        if (pendingDividers.length) {
          pendingDividers.forEach(function (d) { mark(d, Math.max(i, 0)); });
          pendingDividers = [];
        }
      });
    });
    var footer = nav.parentElement.querySelector('.xxx-drawer-footer');
    if (footer) {
      footer.classList.add('xxx-reveal-footer');
      footer.style.setProperty('--xxx-reveal-last', Math.max(i, 0));
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { index(); });
  } else {
    index();
  }
  document.addEventListener('shopify:section:load', function (e) { index(e.target); });
})();

/* ─── メニュードロワー: 子メニュー (第 2 階層) のパネル ─────────────────
   親ボタン (aria-controls="xxx-drawer-panel-…") で子メニューのパネルを開く。
   PC: パネルがドロワーの右に 0.3s で滑り出る。別の親を押すと中身だけ入れ替える
       (いまの中身を 0.15s で消してから、新しい項目を順に表示)。
   スマホ: メインの一覧を 0.25s で消し、同じ場所にパネルを 0.3s で出す。
       「‹ 親の名前」で戻ると、メインの項目をもう一度順に表示する。
   項目は 0.15s ずつ・0.1s ずらしで表示 (動きは custom.css)。
   Dawn はドロワー内の全ボタンに「押したらドロワーを閉じる」処理を付けているので、
   このボタンのクリックは capture で先に受けて、そこから先へ伝えない。
   ドロワーが閉じたら (details の open が外れたら) すべて初期状態に戻す。 */
(function drawerSubPanels() {
  var mobile = window.matchMedia('(max-width: 749px)');
  var timers = [];
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function parts() {
    var details = document.getElementById('Details-menu-drawer-container');
    var container = details && details.querySelector('.xxx-drawer-subpanels');
    return { details: details, container: container };
  }
  function buttons(details) {
    return details.querySelectorAll('.xxx-drawer-nav [aria-controls^="xxx-drawer-panel-"]');
  }
  function indexPanels(container) {
    Array.prototype.forEach.call(container.querySelectorAll('.xxx-drawer-subpanel'), function (panel) {
      var i = 0;
      Array.prototype.forEach.call(panel.children, function (el) {
        el.classList.add('xxx-reveal-sub');
        var isHead = el.classList.contains('xxx-drawer-subpanel__label') || el.hasAttribute('data-xxx-drawer-back');
        el.style.setProperty('--xxx-reveal-i', isHead ? 0 : (i += 1));
      });
    });
  }
  function showPanel(panel, base) {
    panel.hidden = false;
    panel.classList.remove('is-leaving');
    panel.style.setProperty('--xxx-sub-base', base + 's');
    void panel.offsetWidth;
    panel.classList.add('is-active');
  }
  function open(btn, p) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var current = p.container.querySelector('.xxx-drawer-subpanel.is-active');
    if (current === panel && p.container.classList.contains('is-open')) return;
    clearTimers();
    Array.prototype.forEach.call(buttons(p.details), function (b) {
      b.setAttribute('aria-expanded', b === btn ? 'true' : 'false');
    });
    p.details.classList.add('xxx-sub-open');
    p.details.classList.remove('xxx-sub-returned');
    if (current && p.container.classList.contains('is-open')) {
      current.classList.add('is-leaving');
      later(function () {
        current.hidden = true;
        current.classList.remove('is-active', 'is-leaving');
        showPanel(panel, 0);
      }, 150);
    } else {
      p.container.classList.add('is-open');
      showPanel(panel, 0.3);
    }
  }
  function back(p) {
    clearTimers();
    p.container.classList.remove('is-open');
    Array.prototype.forEach.call(buttons(p.details), function (b) { b.setAttribute('aria-expanded', 'false'); });
    p.details.classList.remove('xxx-sub-open');
    p.details.classList.add('xxx-sub-returned');
    later(function () {
      Array.prototype.forEach.call(p.container.querySelectorAll('.xxx-drawer-subpanel'), function (panel) {
        panel.hidden = true;
        panel.classList.remove('is-active', 'is-leaving');
      });
    }, 300);
  }
  function reset(p) {
    clearTimers();
    p.container.classList.remove('is-open');
    p.details.classList.remove('xxx-sub-open', 'xxx-sub-returned');
    Array.prototype.forEach.call(buttons(p.details), function (b) { b.setAttribute('aria-expanded', 'false'); });
    Array.prototype.forEach.call(p.container.querySelectorAll('.xxx-drawer-subpanel'), function (panel) {
      panel.hidden = true;
      panel.classList.remove('is-active', 'is-leaving');
    });
  }
  function init() {
    var p = parts();
    if (!p.container || p.container.dataset.xxxReady) return;
    p.container.dataset.xxxReady = 'true';
    indexPanels(p.container);
    p.details.addEventListener('toggle', function () {
      if (!p.details.open) reset(p);
    });
    mobile.addEventListener('change', function () { reset(p); });
  }
  document.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target : null;
    if (!target) return;
    var btn = target.closest('#menu-drawer .xxx-drawer-nav [aria-controls^="xxx-drawer-panel-"]');
    var backBtn = target.closest('#menu-drawer [data-xxx-drawer-back]');
    if (!btn && !backBtn) return;
    var p = parts();
    if (!p.container) return;
    e.stopPropagation();
    e.preventDefault();
    if (btn) open(btn, p); else back(p);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ─── コレクション別の商品一覧のタブ (sections/xxx-collection-tabs.liquid) ───
   タブを押すと、いまの一覧が 0.3s で下へ 15px 動きながら消え (ease-in)、
   0.2s 後に次の一覧が下から 15px 上がりながら 0.2s で出る (ease-out)。
   左右の矢印キーでタブを移動できる。
   連打しても表示が消えないよう、切り替えのたびに全一覧の状態を決め直し、
   後片付けは終了イベントではなくタイマーで行う (画面が描画されない間も確実に動く)。 */
(function collectionTabs() {
  if (customElements.get('xxx-collection-tabs')) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  customElements.define('xxx-collection-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.select(i); });
        tab.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          next = (next + self.tabs.length) % self.tabs.length;
          self.tabs[next].focus();
          self.select(next);
        });
      });
      // テーマエディタでブロックを選ぶと、そのタブを表示する
      this.addEventListener('shopify:block:select', function (e) {
        var i = self.tabs.indexOf(e.target);
        if (i > -1) self.select(i, true);
      });
    }

    select(index, instant) {
      var toTab = this.tabs[index];
      var fromTab = this.tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      if (!toTab || toTab === fromTab) return;
      var panelOf = function (tab) { return tab && document.getElementById(tab.getAttribute('aria-controls')); };
      var from = panelOf(fromTab);
      var to = panelOf(toTab);
      var token = (this.token = (this.token || 0) + 1);
      this.tabs.forEach(function (t) {
        var on = t === toTab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      // 連打しても状態がずれないよう、毎回すべての一覧を決め直す
      // (途中のアニメーションは止め、表示中と消えていく途中の 1 つ以外は隠す)
      this.tabs.forEach(function (t) {
        var p = panelOf(t);
        if (!p) return;
        p.getAnimations().forEach(function (a) { a.cancel(); });
        p.classList.toggle('is-selected', p === to);
        p.hidden = p !== to && p !== from;
      });
      if (toTab.scrollIntoView) toTab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: instant ? 'auto' : 'smooth' });
      if (!from) return;
      if (instant || reduced.matches || !from.animate) {
        from.hidden = true;
        return;
      }
      from.animate(
        [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(15px)' }],
        { duration: 300, easing: 'ease-in', fill: 'forwards' }
      );
      to.animate(
        [{ opacity: 0, transform: 'translateY(15px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 200, delay: 200, easing: 'ease-out', fill: 'backwards' }
      );
      var self = this;
      setTimeout(function () {
        if (self.token !== token) return;
        from.hidden = true;
        from.getAnimations().forEach(function (a) { a.cancel(); });
      }, 300);
    }
  });
})();
